export default "__VITE_ASSET__6cde6655__"